'use client';

import { useEffect, useRef, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import ProjectMapModal from './ProjectMapModal';
import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  PowerIcon,
  ClipboardDocumentCheckIcon,
  DocumentCheckIcon,
  CalendarDateRangeIcon,
  DocumentTextIcon,
  DocumentPlusIcon,

  PencilIcon,
  CheckBadgeIcon,
  ChevronDoubleRightIcon,
  BookmarkIcon,
  CheckCircleIcon,
  ArrowLeftIcon,
  ChartBarSquareIcon,
  ClockIcon,
  SpeakerWaveIcon,
  DocumentChartBarIcon,
  LinkIcon,
  ChatBubbleBottomCenterTextIcon,
  CubeIcon,
  DocumentMagnifyingGlassIcon,
  MagnifyingGlassCircleIcon,
  BriefcaseIcon,

  



} from '@heroicons/react/20/solid';
import { BookOpenIcon, ScaleIcon, UserGroupIcon, LightBulbIcon, CurrencyPoundIcon } from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import WeatherData from './weatherdata';

import {ViewColumnsIcon, ArrowsRightLeftIcon} from '@heroicons/react/20/solid'


import { ChatBubbleBottomCenterIcon } from '@heroicons/react/16/solid';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import MessageAlert from './messagealert';
import TaskHome from './taskhome';
import ProjectChat from './projectchat';
import ActivityFeed from './activitybar'

import LoadingComponent from './loading';
import { format } from 'date-fns';
import ReactFlow, {
    Controls,
    Background,
    applyNodeChanges,
    applyEdgeChanges,
  } from "reactflow";
  import "reactflow/dist/style.css";
  import { VictoryPie, VictoryLabel } from 'victory';

  import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import { CursorArrowRaysIcon, EnvelopeOpenIcon, SparklesIcon } from '@heroicons/react/24/outline'
import { AcademicCapIcon } from '@heroicons/react/24/solid'
import  ProjectDailyTasks from './projectdailytasks';
import { useLocation } from 'react-router-dom';
import { BuildingOfficeIcon } from '@heroicons/react/24/solid'
import { CreditCardIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import Kanban from './kanban';
import Brainstorm from './Brainstorm';





const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true, feature: 'nav_dashboard' },
  { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false, feature: 'nav_chat' },
  { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false, feature: 'nav_profile' },
  { name: 'Projects', href: '/project-management', icon: ChartBarSquareIcon, current: false, feature: 'nav_projects' },
  { name: 'Sales / Project CRM', href: '/customercrm', icon: UserGroupIcon, current: false, feature: 'nav_customer_crm' },
  { name: 'Task Manager', href: '/taskcalendar', icon: CalendarDateRangeIcon, current: false, feature: 'nav_task_manager' },
  { name: 'Recruitment', href: '/recruitment', icon: BriefcaseIcon, current: false, feature: 'nav_recruitment' },
  { name: 'Admin Tasks', href: '/admin-tasks', icon: DocumentCheckIcon, current: false, feature: 'nav_admin_tasks' },
  { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false, feature: 'nav_training' },
  { name: 'Organization', href: '/organizationaltree', icon: ScaleIcon, current: false, feature: 'nav_organization' },
  { name: 'Users', href: '/users', icon: UserGroupIcon, current: false, feature: 'nav_users' },
  { name: 'Billing', href: '/billing', icon: WalletIcon, current: false, feature: 'nav_billing' },
  { name: 'Docs', href: '/support', icon: DocumentMagnifyingGlassIcon, current: false, feature: 'nav_docs' },
  { name: 'Productivity Insights', href: '/productivity-insights', icon: MagnifyingGlassCircleIcon, current: false, feature: 'nav_productivity_insights' },
  { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false, feature: 'nav_logout' },
];


   
    




function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// Add custom CSS for mobile responsiveness
const responsiveStyles = `
  @media (max-width: 640px) {
    .responsive-container {
      padding: 0.5rem;
    }
    .responsive-text {
      font-size: 0.875rem;
    }
  }
`;

export default function Admin() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const projectSectionRef = useRef(null);
  const projectScrollContainerRef = useRef(null);
  const projectTabsRef = useRef(null);
    const [openProjectModal, setOpenProjectModal] = useState(false);
    const [processes, setProcesses] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [activeProject, setActiveProject] = useState(null);
    const [activeCustomer, setActiveCustomer] = useState(null);
    const [activeCustomerLoading, setActiveCustomerLoading] = useState(false);
    const [customersLoading, setCustomersLoading] = useState(false);
    const [customersError, setCustomersError] = useState(null);

    const emptyFormData = {
      name: "",
      projectType: "External",
      customerId: "",
      brainstormId: '',
      price: "",
      description: "",
      startDate: "",
      endDate: "",
      process: [], // Store selected processes as an array
      objective: "",
      materials: [], // Store project materials
      estimatedHours: "",
      onSite: 0,
    };
    const [formData, setFormData] = useState({
      ...emptyFormData,
    });
    const [openMaterialModal, setOpenMaterialModal] = useState(false);
    const [materialFormData, setMaterialFormData] = useState({
      name: '',
      category: '',
      quantity: 0,
      unit_cost: 0,
      supplier: '',
      notes: '',
      bought: false,
      used: false,
    });
    const [editingMaterialIndex, setEditingMaterialIndex] = useState(null);

    const API_BASE = process.env.REACT_APP_API_URL || 'https://api.insightos.co.uk';
    const MONGO_BASE = process.env.REACT_APP_MONGO_URL || 'https://analytics.insightos.co.uk';
    const [brainstormBoards, setBrainstormBoards] = useState([]);
    const [openReport, setOpenReport] = useState(false);
    const [loading, setLoading] = useState(false);
const [directory, setDirectory] = useState({});
const [projectSteps, setProjectSteps] = useState([]);
const [projectId, setProjectId] = useState(null);
const [isFullscreen, setIsFullscreen] = useState(false);
const [openProjectSteps, setOpenProjectSteps] = useState(false);
const [projectName, setProjectName] = useState(null);
const [meetings, setMeetings] = useState([]);
const [deleteModal , setDeleteModal] = useState(false);
const [activeTab, setActiveTab] = useState('kanban'); // Default active tab
const [mobileActivityOpen, setMobileActivityOpen] = useState(false);
const [searchTerm, setSearchTerm] = useState('');
const [projectMapOpen, setProjectMapOpen] = useState(false);
const [companyGeoTag, setCompanyGeoTag] = useState(null);

const scrollToProjectSection = () => {
  const target = projectTabsRef.current || projectSectionRef.current;
  if (!target) return;

  const container = projectScrollContainerRef.current;
  const offset = 12;

  if (container && container.scrollHeight > container.clientHeight) {
    const targetOffset = target.offsetTop - container.offsetTop - offset;
    container.scrollTo({ top: Math.max(targetOffset, 0), behavior: 'smooth' });
    return;
  }

  const targetRect = target.getBoundingClientRect();
  const absoluteTop = targetRect.top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(absoluteTop, 0), behavior: 'smooth' });
};

console.log(formData);


useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check initially
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

const [isMobile, setIsMobile] = useState(false);

const setProjectType = (type) => {
  setFormData((prev) => ({
    ...prev,
    projectType: type,
    customerId: type === 'External' ? prev.customerId : '',
    price: type === 'External' ? prev.price : '',
    onSite : type === 'External' ? prev.onSite : null,
  }));
};

console.log(projectName);
  
    // Handle input changes for the form
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: name === 'onSite' ? Number(value) : value,
      }));
    };
  
    // Handle process selection change (for multiple processes)
    const handleSelectChange = (e) => {
      const { name, options } = e.target;
      const selectedValues = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
  
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedValues, // Store selected values as an array
      }));
    };

    console.log(formData)
  
    // Handle form submission
    const handleSubmit = async (e) => {
        
      e.preventDefault();
      setLoading(true);

      try {
        const response = await fetch("https://api.insightos.co.uk/api/aiprojectreport", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        if (response.ok) {
          setOpenReport(data.data);
        } else {
          console.error("AI report request failed:", data);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
      };

    // Material management functions
    const handleMaterialInputChange = (e) => {
      const { name, value, type, checked } = e.target;
      setMaterialFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    };

    const handleAddMaterial = () => {
      setMaterialFormData({
        name: '',
        category: '',
        quantity: 0,
        unit: '',
        unit_cost: 0,
        supplier: '',
        notes: '',
        bought: false,
        used: false,
      });
      setEditingMaterialIndex(null);
      setOpenMaterialModal(true);
    };

    const handleSaveMaterial = async () => {
      if (!materialFormData.name.trim()) {
        alert('Material name is required');
        return;
      }

      const newMaterial = {
        ...materialFormData,
        quantity: parseFloat(materialFormData.quantity) || 0,
        unit_cost: parseFloat(materialFormData.unit_cost) || 0,
        added_by: localStorage.getItem('userId') || 'unknown',
        added_at: new Date().toISOString(),
      };

      if (editingMaterialIndex !== null) {
        // Update existing material
        const updatedMaterials = [...(formData.materials || [])];
        updatedMaterials[editingMaterialIndex] = newMaterial;
        setFormData(prev => ({ ...prev, materials: updatedMaterials }));
      } else {
        // Add new material
        setFormData(prev => ({
          ...prev,
          materials: [...(prev.materials || []), newMaterial]
        }));
      }

      // If project already exists, save to backend
      if (projectId) {
        try {
          const materialsToSave = editingMaterialIndex !== null
            ? [...(formData.materials || []).slice(0, editingMaterialIndex), newMaterial, ...(formData.materials || []).slice(editingMaterialIndex + 1)]
            : [...(formData.materials || []), newMaterial];

          console.log('🔄 Saving materials to backend');
          console.log('Project ID:', projectId);
          console.log('Materials to save:', materialsToSave);

          const response = await fetch(`${API_BASE}/api/updatematerials/${projectId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ materials: materialsToSave }),
          });

          const result = await response.json();
          console.log('📦 Save materials response:', result);

          if (response.ok) {
            console.log('✅ Materials saved successfully');
            await handleGetSteps(projectId, projectName, activeProject);
          } else {
            console.error('❌ Failed to save materials:', result);
            alert(`Failed to save materials: ${result.message || 'Unknown error'}`);
          }
        } catch (error) {
          console.error('❌ Error saving material:', error);
          alert(`Error saving material: ${error.message}`);
        }
      }

      // Reset form and close modal
      setMaterialFormData({
        name: '',
        category: '',
        quantity: 0,
        unit: '',
        unit_cost: 0,
        supplier: '',
        notes: '',
        bought: false,
        used: false,
      });
      setEditingMaterialIndex(null);
      setOpenMaterialModal(false);
    };

    const handleEditMaterial = (index) => {
      setMaterialFormData(formData.materials[index]);
      setEditingMaterialIndex(index);
      setOpenMaterialModal(true);
    };

    const handleDeleteMaterial = async (index) => {
      if (!window.confirm('Delete this material?')) return;
      
      const updatedMaterials = formData.materials.filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, materials: updatedMaterials }));

      // If project already exists, save to backend
      if (projectId) {
        try {
          await fetch(`${API_BASE}/api/updatematerials/${projectId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ materials: updatedMaterials }),
          });
          await handleGetSteps(projectId, projectName, activeProject);
        } catch (error) {
          console.error('Error deleting material:', error);
        }
      }
    };

    const handleToggleBought = async (index) => {
      const updatedMaterials = [...formData.materials];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        bought: !updatedMaterials[index].bought
      };
      setFormData(prev => ({ ...prev, materials: updatedMaterials }));

      if (projectId) {
        try {
          await fetch(`${API_BASE}/api/updatematerials/${projectId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ materials: updatedMaterials }),
          });
        } catch (error) {
          console.error('Error updating material:', error);
        }
      }
    };

    const handleToggleUsed = async (index) => {
      const updatedMaterials = [...formData.materials];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        used: !updatedMaterials[index].used
      };
      setFormData(prev => ({ ...prev, materials: updatedMaterials }));

      if (projectId) {
        try {
          await fetch(`${API_BASE}/api/updatematerials/${projectId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ materials: updatedMaterials }),
          });
        } catch (error) {
          console.error('Error updating material:', error);
        }
      }
    };
  
    // Fetch processes from the API
    const getProcess = async () => {
        
      try {
        const response = await fetch("https://api.insightos.co.uk/api/process", {
          method: "GET",
          headers: { }, credentials: 'include',
        });
        const data = await response.json();
  
        if (data.success) {
          setProcesses(data.data); // Update processes state with the fetched data
        } else {
          console.error("Failed to fetch processes:", data.message);
        }
      } catch (error) {
        console.error("Error fetching processes:", error);
      }
    };

    const getCustomers = async () => {
      setCustomersLoading(true);
      setCustomersError(null);
      try {
        const response = await fetch("https://api.insightos.co.uk/api/customers", {
          method: "GET",
          headers: {},
          credentials: 'include',
        });
        const data = await response.json();

        if (data && data.success && Array.isArray(data.customers)) {
          setCustomers(data.customers);
        } else {
          setCustomers([]);
          setCustomersError(data?.message || "Failed to fetch customers");
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        setCustomers([]);
        setCustomersError("Error fetching customers");
      } finally {
        setCustomersLoading(false);
      }
    };

    const fetchProjects = async () => {
        const token = localStorage.getItem("token");    

        try {
            const response = await fetch("https://api.insightos.co.uk/api/getproject", {
                method: "GET",

                headers: { }, credentials: 'include',
            });
            const data = await response.json();

            if (data.success) {
                // Sort all projects by StartDate DESC (future dates first)
                const sortedProjects = Array.isArray(data.data) 
                    ? data.data.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate))
                    : [];
                setProjects(sortedProjects);
                
                // Group by month/year
                const dir = sortedProjects.reduce((acc, proc) => {
                    const dateKey = proc.StartDate ? format(new Date(proc.StartDate), 'MMMM yyyy') : 'No Date';
                    if (!acc[dateKey]) acc[dateKey] = [];
                    acc[dateKey].push(proc);
                    return acc;
                }, {});
                setDirectory(dir);
            } else {
                console.error("Failed to fetch projects:", data.message);
            }

        } catch (error) {

            console.error("Error fetching projects:", error);

        }

    };

    const fetchCustomerById = async (customerId) => {
      const normalized = customerId === undefined || customerId === null ? '' : String(customerId);
      if (!normalized.trim()) {
        setActiveCustomer(null);
        return;
      }

      setActiveCustomerLoading(true);
      try {
        const response = await fetch(`https://api.insightos.co.uk/api/customers?id=${encodeURIComponent(normalized)}`, {
          method: 'GET',
          headers: {},
          credentials: 'include',
        });

        const data = await response.json();
        const list = data && data.success && Array.isArray(data.customers) ? data.customers : [];
        setActiveCustomer(list.length > 0 ? list[0] : null);
      } catch (error) {
        console.error('Error fetching customer by id:', error);
        setActiveCustomer(null);
      } finally {
        setActiveCustomerLoading(false);
      }
    };


    // i want to get project steps when the useLocation triggers the project id

    const location = useLocation();


    useEffect(() => {

        if (location.state) {

            // get the project id from the location state

            const projectId = location.state.projectId;

            const foundProject = projects.find((p) => String(p?.id) === String(projectId));
            if (foundProject) {
              setActiveProject(foundProject);
              const customerId = foundProject?.CustomerId ?? foundProject?.customerId;
              if (customerId !== null && customerId !== undefined && String(customerId).trim() !== '') {
                fetchCustomerById(customerId);
              } else {
                setActiveCustomer(null);
              }
            }

            // now we want to get the steps for this project

            handleGetSteps(projectId);
            setActiveTab('chat')

        }

  }, [location, projects]);



   


const Navigate = useNavigate();




    useEffect(() => {
        fetchProjects();
    }, []);



  
    // Fetch processes when the component mounts or the modal opens
    useEffect(() => {
      if (openProjectModal) {
        getProcess(); // Fetch processes when the modal is open
        getCustomers();
        fetchBrainstormBoards();
      }
    }, [openProjectModal]);

    const fetchBrainstormBoards = async () => {
      try {
        const response = await fetch(`${MONGO_BASE}/api/brainstorms`, {
          method: 'GET',
          credentials: 'include',
        });

        const payload = await response.json();
        if (!response.ok || !payload?.success) {
          throw new Error(payload?.message || 'Failed to load brainstorm boards');
        }

        setBrainstormBoards(Array.isArray(payload.data) ? payload.data : []);
      } catch (error) {
        console.error('Failed to fetch brainstorm boards', error);
        setBrainstormBoards([]);
      }
    };

    const handleSaveData = async () => {
        setLoading(true);
    
        try {
            // Create a new object to avoid mutating state directly
            const requestData = { ...formData, openReport };
    
            const response = await fetch("https://api.insightos.co.uk/api/projectsave", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',

                body: JSON.stringify(requestData),
            });
    
            // Check if the response is OK before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
    
            if (response.status === 202 && data.queued && data.jobId) {
                setOpenProjectModal(false);
                setOpenReport(false);
                setFormData(emptyFormData);
                Navigate(`/job-progress/${data.jobId}`, {
                  state: {
                    title: 'Creating project schedule',
                    successPath: '/project-management',
                    backPath: '/project-management',
                  },
                });
                return;
            }

            if (data.success) {
                console.log("Data saved successfully:", data);
                setOpenProjectModal(false);
                setOpenReport(false);
                setFormData(emptyFormData);
                fetchProjects();
                window.location.reload(); // Force a full page reload to update the directory and project list
            } else {
                console.error("Server responded with an error:", data);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Callback for child component to trigger refetch
    const handleChildDataChange = async () => {
      if (projectId) {
        await handleGetSteps(projectId, projectName, activeProject);
      }
    };

    const handleGetSteps = async (id, name, projectMeta = null) => {
      try {
        const response = await fetch(`https://api.insightos.co.uk/api/getprojectsteps/${id}`, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        const data = await response.json();

        if (response.ok) {
          // Get current date and time
          const now = new Date();
          const currentDate = format(now, "yyyy-MM-dd");
          // Add kanban status to each task
          const tasksWithStatus = data.data.map(task => {
            // Skip assigning kanban status if the task is a Break task
            if (task.Task === "Break") {
              return { ...task, kanbanStatus: "Break" }; // Special status that won't appear in kanban
            }
            
            // Default status based on completion
            let kanbanStatus = "todo";
            
            // If task is completed
            if (task.Completed === 1) {
              kanbanStatus = "completed";
            } 
            // If task is today and not completed, mark as in-progress
            else {
              const taskDate = format(new Date(task.TaskDate), "yyyy-MM-dd");
              if (taskDate === currentDate) {
          kanbanStatus = "in-progress";
              }
            }
            
            return { ...task, kanbanStatus };
          }).sort((a, b) => {
            // Sort by date within each kanban status category
            const dateA = new Date(a.TaskDate);
            const dateB = new Date(b.TaskDate);
            
            // First sort by kanban status to keep the grouping
            if (a.kanbanStatus !== b.kanbanStatus) {
              return 0; // Keep original grouping order
            }
            
            // Then sort by date within each status group (earliest first)
            return dateA - dateB;
          });
          
          // Sort tasks by date and time
          const sortedData = tasksWithStatus.sort((a, b) => {
            const dateA = new Date(a.TaskDate + " " + a.StartTime);
            const dateB = new Date(b.TaskDate + " " + b.StartTime);
            return dateA - dateB;
          });

// remove Break tasks from the sortedData

          

          console.log("Project steps:", sortedData);
          setProjectSteps(sortedData);
          setOpenProjectSteps(true);
          setProjectId(id);
          setProjectName(name);

          // Use project data from API response first, then fallback to projectMeta or found project
          const projectData = data.project || projectMeta || projects.find((p) => String(p?.id) === String(id));

          if (projectData) {
            setActiveProject(projectData);
            const customerId = projectData?.CustomerId ?? projectData?.customerId;
            if (customerId !== null && customerId !== undefined && String(customerId).trim() !== '') {
              fetchCustomerById(customerId);
            } else {
              setActiveCustomer(null);
            }
            // Load materials from project data
            if (projectData.Materials) {
              try {
                const materialsData = typeof projectData.Materials === 'string' 
                  ? JSON.parse(projectData.Materials) 
                  : projectData.Materials;
                setFormData(prev => ({ ...prev, materials: Array.isArray(materialsData) ? materialsData : [] }));
              } catch (e) {
                console.error('Error parsing materials:', e);
                setFormData(prev => ({ ...prev, materials: [] }));
              }
            } else {
              setFormData(prev => ({ ...prev, materials: [] }));
            }
          }

          const meetings = data.meetings;
          console.log("Meetings:", meetings);
          setMeetings(meetings);
        } else {
          console.error("Failed to fetch project steps:", data.message);
        }
      } catch (error) {
        console.error("Error fetching project steps:", error);
      }
    };

    useEffect(() => {
        // if projectSteps is not empty, then set a timeout on handleGetSteps to refresh the data every 5 minutes
        if (projectSteps.length > 0) {
            const interval = setInterval(() => {
                handleGetSteps(projectId);
                currentProgress();
            }, 60000); // 5 minutes
            return () => clearInterval(interval);
        }
    }, [projectSteps]);


    const [selectedNode, setSelectedNode] = useState(null); // To store the selected node's data

    const handleNodeClick = (_event, node) => {
      // Find the node data and set it to the selectedNode state
      const selectedStep = projectSteps.find(step => step.TaskID.toString() === node.id);
      setSelectedNode(selectedStep);
    };

    const nodeSpacingX = 140; // 🔽 Reduce horizontal spacing
    const nodeSpacingY = 400; // 🔽 Reduce vertical spacing

    // 🛠 Group steps by ProcessId (Each ProcessId gets its own row)
    const groupedSteps = projectSteps.reduce((acc, step) => {
      if (!acc[step.ProcessId]) acc[step.ProcessId] = [];
      acc[step.ProcessId].push(step);
      return acc;
    }, {});

    // Function to convert time string (hh:mm:ss) to x position
    const timeToPosition = (timeString) => {
      // Default to 7am if time is invalid
      if (!timeString) return 0;
      
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      
      // Calculate position relative to 7am (start) and 7pm (end)
      const startHour = 7; // 7am
      const endHour = 19;  // 7pm
      const totalHours = endHour - startHour;
      const timeInHours = hours + minutes/60 + (seconds || 0)/3600;
      
      // Normalize to our timeline (0 = 7am, 1200 = 7pm)
      // Ensure time is within our range
      const normalizedPosition = Math.max(0, Math.min(1, (timeInHours - startHour) / totalHours));
      return normalizedPosition * 1200; // Scale to 1200px width
    };

    // Generate hour markers for timeline
    const hourMarkers = Array.from({ length: 13 }, (_, i) => {
      const hour = i + 7; // Start from 7am
      return {
        id: `hour-${hour}`,
        data: { label: `${hour > 12 ? hour - 12 : hour}${hour >= 12 ? 'pm' : 'am'}` },
        position: { x: timeToPosition(`${hour}:00:00`), y: -40 },
        style: {
          width: 100,
          height: 20,
          fontSize: '10px',
          background: 'transparent',
          border: 'none',
          color: '#fff',
          textAlign: 'center',
        },
      };
    });

    // Create flow view nodes
    const flowNodes = Object.entries(groupedSteps).flatMap(([_processId, steps], rowIndex) =>
      steps.flatMap((step, colIndex) => {
        const isCompleted = step.Completed === 1;
        const backgroundColor = isCompleted ? "#00FF88" : "#FF3131"; // 🟢 Completed / 🔴 Not Completed
        const nodesList = [];

        // 🔷 Main Step Node with position indicator
        nodesList.push({
          id: step.TaskID?.toString(),
          data: { label: `${colIndex + 1}/${steps.length}: ${step.Role} - ${step.Name} - ${step.Task} (${step.Description}) ${step.StartTime} (${format(new Date(step.TaskDate), "dd/MM/yyyy")})` },
          position: { x: colIndex * nodeSpacingX, y: rowIndex * nodeSpacingY },
          style: {
            background: backgroundColor,
            color: "#fff",
            borderRadius: "10px",
            boxShadow: `0px 0px 8px ${backgroundColor}`,
            padding: "8px",
            fontSize: "12px",
            width: 120,
          },
        });

        // 🟡 Issue Nodes (Circles)
        (step.issues || []).forEach((issue, issueIndex) => {
          nodesList.push({
            id: `issue-${step.TaskID}-${issueIndex}`,
            data: { label: issue.Name || "Issue" },
            position: { // Add position property for issue nodes
              x: colIndex * nodeSpacingX + 0, 
              y: rowIndex * nodeSpacingY + 200 + issueIndex * 70
            },
            style: {
              background: "#FFD700",
              color: "#000",
              borderRadius: "50%", // 🟡 Circle shape
              width: 50,
              height: 50,
              fontSize: "10px",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 6px #FFD700",
            },
          });

        // Add help nodes if issue has help info (may be multiple)
        if (issue.help && issue.help.length > 0) {
        issue.help.forEach((helpItem, helpIndex) => {
          nodesList.push({
          id: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
          data: { label: helpItem.StaffName },
          position: { 
            x: colIndex * nodeSpacingX + 0, 
            y: rowIndex * nodeSpacingY + 300 + issueIndex * 50 + helpIndex * 30 
          },
          style: {
            background: "#4A90E2",
            color: "#fff",
            borderRadius: "5px",
            padding: "5px",
            fontSize: "10px",
            width: 100,
            boxShadow: "0px 0px 6px #4A90E2",
          },
          });
        });
        }
      });

      return nodesList;
      })
    ).flat();

    // Group steps by date for timeline view
    const stepsByDate = projectSteps.reduce((acc, step) => {
      const dateKey = format(new Date(step.TaskDate), "yyyy-MM-dd");
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(step);
      return acc;
    }, {});

    // Sort steps within each date by StartTime
    Object.values(stepsByDate).forEach(steps => {
      steps.sort((a, b) => {
      return a.StartTime.localeCompare(b.StartTime);
      });
    });

    // Get sorted dates for timeline view
    const sortedDates = Object.keys(stepsByDate).sort();

    // Create timeline nodes with improved spacing and positioning
    const timelineNodes = [
      // Add horizontal line for timeline
      {
        id: 'timeline-base',
        data: { label: '' },
        position: { x: 0, y: 0 },
        style: {
          width: 1200,
          height: 2,
          background: '#fff',
          borderRadius: 0,
        },
      },
      // Add hour markers
      ...hourMarkers,
      // Add date headers and tasks
      ...sortedDates.flatMap((dateKey, dateIndex) => {
        const steps = stepsByDate[dateKey];
        const verticalOffset = dateIndex * 250; // Spacing between dates
        
        // Create date header node
        const dateNodes = [{
          id: `date-${dateKey}`,
          data: { label: format(new Date(dateKey), "EEE, dd MMM yyyy") },
          position: { x: -150, y: 30 + verticalOffset },
          style: {
            background: '#3b82f6',
            color: '#fff',
            borderRadius: '5px',
            padding: '4px',
            fontSize: '12px',
            width: 130,
            height: 30,
            textAlign: 'center',
            fontWeight: 'bold',
          },
        },
        // Add horizontal line for this date
        {
          id: `dateline-${dateKey}`,
          data: { label: '' },
          position: { x: 0, y: 45 + verticalOffset },
          style: {
            width: 1200,
            height: 1,
            background: '#3b82f6',
            opacity: 0.5,
          },
        }];
        
        // Group tasks by time slot to manage vertical positioning
        const timeSlots = {};
        steps.forEach(step => {
          const timeKey = step.StartTime.substring(0, 5); // HH:MM format
          if (!timeSlots[timeKey]) timeSlots[timeKey] = [];
          timeSlots[timeKey].push(step);
        });
        
        // Calculate hour width based on total timeline width
        const totalHours = 12; // 7am to 7pm
        const timelineWidth = 1200;
        const hourWidth = timelineWidth / totalHours;
        
        // Create task nodes for each time slot
        const taskNodes = [];
        
        Object.entries(timeSlots).forEach(([_timeKey, slotSteps]) => {
          slotSteps.forEach((step, stepIndex) => {
            const isCompleted = step.Completed === 1;
            // isBreak is a special task that we want to color in yellow 
            const backgroundColor = isCompleted ? "#00FF88" : "#FF3131";
            

            
            
            // Calculate exact x position based on time
            const xPos = timeToPosition(step.StartTime);
            
            // Calculate vertical position with enough space between tasks at same time
            const yOffset = stepIndex * 60;
            
            // Ensure node is centered at the time position
            taskNodes.push({
              id: step.TaskID?.toString(),
              data: { 
                label: `${step.Task} - ${step.Role} - ${step.Name}`,
                stepId: step.TaskID.toString() 
              },
              position: { 
                x: xPos,  // Position exactly at the time marker
                y: 60 + verticalOffset + yOffset
              },
              style: {
                background: backgroundColor,
                color: "#fff",
                borderRadius: "5px",
                top: 5,
                padding: "7px",
                fontSize: "7px",
                left: 45,
                width: hourWidth, // Match width to the hour width
                height: 50,
                textAlign: 'center',
                boxShadow: `0px 0px 8px ${backgroundColor}`,
              },
            });
          });
        });
        
        return [...dateNodes, ...taskNodes];
      })
    ];

    // Determine which nodes to use based on view mode
    const nodes = activeTab === 'flow' ? flowNodes : timelineNodes;

    // Only generate edges for flow view, not for timeline view
    const edges = activeTab === 'flow' ? Object.entries(groupedSteps).flatMap(([_processId, steps]) =>
      steps.flatMap((step, index, array) => {
        const mainStepId = step.TaskID?.toString();
        const edgesList = [];

        // 🔹 Edges between issues and their step
        (step.issues || []).forEach((issue, issueIndex) => {
          const issueId = `issue-${step.TaskID}-${issueIndex}`;
          
          // Add edge from main step to issue
          edgesList.push({
            id: `e-${mainStepId}-issue-${issueIndex}`,
            source: mainStepId,
            target: issueId,
            animated: true,
            style: { stroke: "#FFD700", strokeWidth: 1.5 },
          });
          
          // 🔷 Add edges from issue to each help item
          if (issue.help && issue.help.length > 0) {
            issue.help.forEach((helpItem, helpIndex) => {
              edgesList.push({
                id: `e-issue-${step.TaskID}-${issueIndex}-help-${helpIndex}`,
                source: issueId,
                target: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
                animated: true,
                style: { stroke: "#4A90E2", strokeWidth: 1.5, strokeDasharray: "5 5" },
              });
            });
          }
        });

        // 🔹 Connect steps within the same ProcessId (same row)
        if (index > 0) {
          edgesList.push({
            id: `e-${array[index - 1].TaskID}-${step.TaskID}`,
            source: array[index - 1].TaskID?.toString(),
            target: mainStepId,
            animated: true,
            style: { stroke: "#FFFFFF", strokeWidth: 1.5 },
          });
        }

        return edgesList;
      })
    ).flat() : []; // Empty array for timeline view - no connections

    // now we want to work out the stats for the project so if we are ahead or behind so we need to map through projectSteps to find out how many steps for each day and then how many are completed

    const currentProgress = () => {
      const today = new Date();

      // use date fns to match today with the .TaskDate 
      const stepsToday = projectSteps.filter(step => format(new Date(step.TaskDate), "dd/MM/yyyy") === format(today, "dd/MM/yyyy"));

      // okay now using today get the current time and use the StartTime which is hh:mm:ss to see how many tasks are up to this time

      // use date fns to get the current time

      const currentTime = format(today, "HH:mm:ss");

      // now we need to filter the stepsToday to see how many are up to the current time

      const stepsUpToNow = stepsToday.filter(step => step.StartTime <= currentTime);

      console.log("Steps up to now:", stepsUpToNow);

      console.log("Steps today:", stepsToday);

      // find out with steps up to now how many are completed

      const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;

      return {
      totalSteps: stepsToday.length,
      completedSteps
      };
    };

    console.log(currentProgress());

    const overallProgress = () => {
      // Check if projectSteps is empty
      if (projectSteps.length === 0) {
      return {
        totalSteps: 0,
        completedSteps: 0
      };
      }

      const today = new Date();
      const currentDate = format(today, "dd/MM/yyyy");
      const currentTime = format(today, "HH:mm:ss");

      // Get all steps up to now (steps from previous days + today's steps up to current time)
      const stepsUpToNow = projectSteps.filter(step => {
      const stepDate = format(new Date(step.TaskDate), "dd/MM/yyyy");
      
      // Include if step date is before today
      if (stepDate < currentDate) return true;
      
      // Include if step date is today AND step time is up to current time
      if (stepDate === currentDate && step.StartTime <= currentTime) return true;
      
      return false;
      });

      // Count completed steps
      const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;

      console.log("Steps up to now:", stepsUpToNow);
      console.log(`Overall progress: ${completedSteps}/${stepsUpToNow.length} steps completed`);

      return {
      totalSteps: stepsUpToNow.length,
      completedSteps
      };
    };

    console.log(overallProgress());

    const NodeDetailsModal = ({ nodeData, onClose }) => {
      if (!nodeData) return null;

      const bgColor = nodeData.Completed === 1 ? "bg-emerald-500" : "bg-red-500";

      return (
      <div className="flex items-center justify-center bg-black bg-opacity-50 w-full h-full z-50">
        <div className={`shadow-lg rounded-lg p-4 w-80 text-white ${bgColor}`}>
        {/* Header */}
        <div className="p-2 text-sm font-semibold text-center">Node Details</div>
        
        {/* Content */}
        <div className="p-2 space-y-2 text-xs">
          <p><strong>Role:</strong> {nodeData.Role}</p>
          <p><strong>Process:</strong> {nodeData.ProcessName}</p>
          <p><strong>Task:</strong> {nodeData.Task}</p>
          <p><strong>Name:</strong> {nodeData.Name}</p>
          <p><strong>Description:</strong> {nodeData.Description}</p>
          <p><strong>Start Time:</strong> {nodeData.StartTime}</p>
          <p><strong>Task Date:</strong> {format(new Date(nodeData.TaskDate), "dd/MM/yyyy")}</p>
          {nodeData !== null && (
          <p><strong>Outcome:</strong> {nodeData.Outcome}</p>
          )}
          
          {/* Issues Section */}
          {nodeData.issues?.length > 0 && (
          <div className="mt-2">
            <h3 className="font-semibold text-sm">Issues:</h3>
            {nodeData.issues.map((issue, index) => (
            <div key={index} className="p-2 rounded border border-white mt-1">
              <p><strong>Issues:</strong> {issue.length} issues</p>
            
              {issue.help?.length > 0 && (
              <div className="mt-1">
                <h4 className="font-semibold text-xs">Help:</h4>
                {issue.help.map((helpItem, helpIndex) => (
                <div key={helpIndex} className="p-1 rounded border border-white mt-1">
                  <p><strong>{helpItem.StaffName}</strong></p>
                </div>
                ))}
              </div>
              )}
            </div>
            ))}
          </div>
          )}
        </div>
        
        {/* Close Button */}
        <div className="p-2 flex justify-end">
          <button onClick={onClose} className="px-3 py-1 bg-white text-black rounded hover:bg-gray-300 text-xs">
          Close
          </button>
        </div>
        </div>
      </div>
      );
    };

const handleOpenGoogleMaps = (postcode) => {
  if (!postcode) return;
  const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(postcode)}`;
  window.open(url, '_blank');
};





const handleOpenProjectMap = async () => {
  try {
    const response = await fetch(`${API_BASE}/api/company-geotag`, {
      method: 'GET',
      credentials: 'include',
    });
    const data = await response.json();
    if (data.success) {
      setCompanyGeoTag(data.companyGeoTag);
      setProjectMapOpen(true);
    }
  } catch (error) {
    console.error('Error fetching company geotag:', error);
  }
};

const handleDeleteProject = async () => {

    try {

        const response = await fetch(`https://api.insightos.co.uk/api/deleteproject/${projectId}`, {

            method: "DELETE",
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',

        });

        const data = await response.json();

        if (data.success) {

            console.log("Project deleted successfully:", data);

            setDeleteModal(false);
            setOpenProjectSteps(false);
            setActiveProject(null);
            setProjectId(null);
            await fetchProjects(); // Refresh project list


        } else {

            console.error("Failed to delete project:", data.message);

        }

    } catch (error) {

        console.error("Error deleting project:", error);

    }

};





  
    const stats = [
        {
            id: 1,
            name: "Total Project Steps",
            stat: projectSteps.length || "0",
            change: "100%",
            changeType: "increase",
            icon: DocumentDuplicateIcon,
        },
        {
            id: 2,
            name: "Completed Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed === 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed === 1).length || "0"} steps`,
            changeType: "increase",
            icon: ClipboardDocumentCheckIcon,
        },
        {
            id: 3,
            name: "Pending Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed !== 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed !== 1).length || "0"} steps`,
            changeType: "decrease",
            icon: DocumentCheckIcon,
        },
        {
            id: 4,
            name: "Current Daily Progress",
            stat: currentProgress().totalSteps > 0 
                ? `${Math.round((currentProgress().completedSteps / currentProgress().totalSteps) * 100)}%` 
                : "0%",
            change: (() => {
                const prog = currentProgress();
                const hoursDiff = prog.totalSteps - prog.completedSteps;
                return hoursDiff > 0 
                    ? `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} behind` 
                    : hoursDiff < 0 
                        ? `${Math.abs(hoursDiff)} hour${Math.abs(hoursDiff) !== 1 ? 's' : ''} ahead` 
                        : "On target";
            })(),
            changeType: currentProgress().totalSteps > 0 && 
                (currentProgress().completedSteps / currentProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
        {
            id: 5,
            name: "Overall Progress",
            stat: overallProgress().totalSteps > 0 
                ? `${Math.round((overallProgress().completedSteps / overallProgress().totalSteps) * 100)}%` 
                : "0%",
            change: `${overallProgress().completedSteps}/${overallProgress().totalSteps} steps`,
            changeType: overallProgress().totalSteps > 0 && 
                (overallProgress().completedSteps / overallProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
    ];
    
    // Calculate profit margin for color coding (for External projects)
    const getProfitMarginColor = (margin) => {
        if (margin < 20) return '#ef4444';
        if (margin <= 30) return '#eab308';
        return '#10b981';
    };
    
    const profitMargin = activeProject?.Price > 0 
        ? ((activeProject.NetProfit / activeProject.Price) * 100).toFixed(1) 
        : 0;
    
    


    const tabs = [
      { name: 'Kanban', id: 'kanban', icon: ViewColumnsIcon, current: activeTab === 'kanban' },
      { name: 'Gantt', id: 'timeline', icon: ClockIcon, current: activeTab === 'timeline' },
      { name: 'Flow Chart', id: 'flow', icon: ArrowsRightLeftIcon, current: activeTab === 'flow' },
      { name: 'Meetings', id: 'meetings', icon: CalendarDaysIcon, current: activeTab === 'meetings' },
      {name: 'Chat', id: 'chat', icon: ChatBubbleBottomCenterTextIcon, current: activeTab === 'chat'},
      { name: 'Brainstorm', id: 'brainstorm', icon: SparklesIcon, current: activeTab === 'brainstorm' },
      ...(activeProject?.ProjectType === 'External' ? [{ name: 'Materials', id: 'materials', icon: DocumentCheckIcon, current: activeTab === 'materials' }] : []),
      { name: 'Daily Report', id: 'daily-report', icon: DocumentChartBarIcon, current: activeTab === 'daily-report' },
    ];
      useEffect(() => {
        const handleClickOutside = (event) => {
          const activityFeedContainer = document.getElementById('mobile-activity-feed');
          const activityToggleButton = document.getElementById('activity-toggle-button');
          
          if (
            mobileActivityOpen &&
            activityFeedContainer && 
            !activityFeedContainer.contains(event.target) &&
            activityToggleButton &&
            !activityToggleButton.contains(event.target)
          ) {
            setMobileActivityOpen(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [mobileActivityOpen]);
    
    


return (
    <>
        <div>
        <div className="flex h-screen">
        {/* Sidebar (Fixed for Desktop) */}
        <div className="hidden lg:flex lg:flex-col lg:w-[80px] lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:bg-gradient-to-t from-emerald-600 via-indigo-600 to-purple-700 lg:pb-4 overflow-y-auto">
            <div className="flex h-16 items-center justify-center">
                <img alt="Logo" src="/2.png" className="h-10 mt-2 w-auto rounded-full bg-gray-900" />
            </div>
            <nav className="mt-8 flex flex-col items-center space-y-1">
                {navigation.map((item) => (
                    <div key={item.name} className="relative">
                        <Link
                            to={item.href}
                            className={`group flex items-center justify-center p-3 rounded-md ${
                                item.current ? "bg-white text-blue-700" : "text-white hover:bg-blue-700"
                            }`}
                        >
                            <item.icon className="h-6 w-6" />
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 scale-0 rounded-md bg-gray-700 px-3 py-1 text-xs text-white shadow-lg transition-all duration-150 group-hover:scale-100">
  {item.name}
</span>
                        </Link>
                    </div>
                ))}
            </nav>
        </div>

        {/* Sidebar (Mobile - Dialog) */}
        <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="lg:hidden relative z-[60]">
            <DialogBackdrop className="fixed inset-0 bg-white opacity-75 transition-opacity" />
            <div className="fixed inset-0 flex z-[60]">
                <DialogPanel className="w-full max-w-xs transform transition-all duration-300">
                    <div className="bg-gradient-to-br from-blue-700 via-indigo-600 to-purple-700 p-6">
                        <div className="flex justify-between items-center">
                            <img alt="Logo" src="/2.png" className="h-8 rounded-full bg-gray-900" />
                            <button onClick={() => setSidebarOpen(false)}>
                                <XMarkIcon className="h-6 w-6 text-white" />
                            </button>
                        </div>
                        <nav className="mt-8">
                            <ul className="space-y-2">
                                {navigation.map((item) => (
                                    <li key={item.name}>
                                        <Link
                                            to={item.href}
                                            className="flex items-center text-white hover:bg-blue-700 p-3 rounded-md"
                                        >
                                            <item.icon className="h-6 w-6" />
                                            <span className="ml-3">{item.name}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>

        {/* Main Content Wrapper */}
        <div className="flex flex-1 flex-col lg:ml-[80px] overflow-hidden pb-20 sm:pb-0">
            {/* Top Navbar (Mobile Only) */}
            <div className="sticky top-0 z-40 flex items-center bg-gradient-to-l from-indigo-900 via-sky-500 to-emerald-500 px-4 py-4 shadow-sm lg:hidden">
                     <button onClick={() => setSidebarOpen(true)} className="text-white">
                       <Bars3Icon className="h-6 w-6" />
                     </button>
                     <div className="flex-1 text-white font-semibold ml-3">Dashboard</div>
                     <button 
                       id="activity-toggle-button"
                       onClick={() => setMobileActivityOpen(!mobileActivityOpen)}
                       className="text-white mr-3 relative"
                       aria-label="Toggle sidebar menu"
                     >
                       <ChartBarSquareIcon className="h-6 w-6" />
                       <span className="absolute -top-1 -right-1 flex h-3 w-3">
                         <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                         <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                       </span>
                     </button>
                     <Link 
                       to="/logout" 
                       className="flex items-center justify-center text-white p-1 rounded-full hover:bg-blue-700"
                       aria-label="Logout"
                     >
                       <PowerIcon className="h-6 w-6" />
                     </Link>
                   </div>
                    <AnimatePresence>
                             {mobileActivityOpen && (
                               <motion.div 
                                 id="mobile-activity-feed"
                                 initial={{ opacity: 0, x: '100%' }}
                                 animate={{ opacity: 1, x: 0 }}
                                 exit={{ opacity: 0, x: '100%' }}
                                 transition={{ duration: 0.3 }}
                                 className="lg:hidden fixed inset-0 z-50 bg-white overflow-y-auto max-h-full"
                                 style={{ overscrollBehavior: 'contain' }}
                               >
                                 <div className="flex flex-col h-full">
                                   <div className="sticky top-0 bg-white z-10 p-4 border-b border-gray-200">
                                     <div className="flex justify-between items-center">
                                       <h3 className="font-semibold text-gray-800 flex items-center">
                                         <ChartBarSquareIcon className="h-5 w-5 mr-2 text-blue-500" />
                                         Dashboard Menu
                                       </h3>
                                       <button 
                                         onClick={() => setMobileActivityOpen(false)}
                                         className="text-gray-500 hover:text-gray-700 bg-gray-100 rounded-full p-1"
                                       >
                                         <XMarkIcon className="h-5 w-5" />
                                       </button>
                                     </div>
                                   </div>
                                   <div className="flex-1 overflow-y-auto p-4">
                                     <WeatherData />
                                   
                                     <div className="mt-4 flex flex-wrap gap-2">
                                       <button
                                         type="button"
                                         onClick={() => {
                                           Navigate("/createmeeting");
                                           setMobileActivityOpen(false);
                                         }}
                                         className="flex-1 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                       >            
                                         <CalendarIcon className="h-6 w-6" />
                                         Create Meeting
                                       </button>
                                       <button
                                         type="button"
                                         onClick={() => {
                                           SetAI(true);
                                           setMobileActivityOpen(false);
                                         }}
                                         className="flex-1 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                       >            
                                         <LightBulbIcon className="h-6 w-6" />
                                         Support
                                       </button>
                                     </div>
                                     {/* Activity Feed */}
                                     <div className="mt-4 pb-20"> {/* Added padding at the bottom */}
                                       <ActivityFeed mobileView={true} />
                                     </div>
                                   </div>
                                 </div>
                               </motion.div>
                             )}
                           </AnimatePresence>
                   

            {/* Content Layout */}
            <div className="flex h-full flex-col md:flex-row">
                {/* Sidebar for Extra Features */}
                {!openProjectSteps && (
                <div className={`w-full md:w-1/2 lg:w-1/3 xl:w-1/3 border-b md:border-b-0 md:border-r border-gray-200 p-4 md:p-6 ${openProjectModal ? 'hidden' : 'block'} md:block overflow-y-auto`}>
                <WeatherData />
                <div className="mt-4 flex justify-center md:justify-start">
                    <button
                        type="button"
                        onClick={() => setOpenProjectModal(true)}
                        className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >            
                        <PencilIcon className="h-5 w-5 md:h-6 md:w-6" />
                        Create Project
                    </button>
                    
                 
                </div>
                
                {/* Search Bar */}
                <div className="mt-4 px-3">
                    <input
                        type="text"
                        placeholder="Search by Client Name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-2"
                    />
                </div>

                <nav aria-label="Directory" className="h-full overflow-y-auto mt-4">
                {Object.keys(directory)
                    .map((key) => {
                        // Filter projects by search term
                        const filteredProjects = directory[key].filter(proc => {
                            if (!searchTerm) return true;
                            const clientName = proc.ClientName || '';
                            return clientName.toLowerCase().includes(searchTerm.toLowerCase());
                        });
                        
                        // Skip empty groups
                        if (filteredProjects.length === 0) return null;
                        
                        return (
                        <div key={key} className="mb-4">
                            <div className="sticky top-0 z-10 border-b bg-gray-50 px-3 py-1.5 text-sm font-semibold text-gray-900">
                                {key}
                            </div>
        

{filteredProjects.map((proc) => {
const bgColor = proc.Active === 1 ? "bg-emerald-500" : "bg-red-500";
const formattedStartDate = proc.StartDate ? format(new Date(proc.StartDate), "dd/MM/yyyy") : "N/A";
const formattedEndDate = proc.EndDate ? format(new Date(proc.EndDate), "dd/MM/yyyy") : "N/A";
const hasPrice = proc.Price !== null && proc.Price !== undefined && String(proc.Price).trim() !== '';

return (
    <div
        key={proc.id}
        className={`w-full flex flex-col md:flex-row justify-between items-start md:items-center mt-3 px-3 py-4 ${bgColor} rounded-lg shadow-md text-white cursor-pointer`}
    onClick={() => handleGetSteps(proc.id, proc.Name, proc)}
    >
        <div className="min-w-0 flex-1">
            <p className="text-base md:text-sm font-semibold">{proc.Name}</p>
            <p className="mt-1 truncate text-sm md:text-xs">{proc.Description}</p>
            <p className="mt-1 text-sm md:text-xs">{proc.Author}</p>
      {hasPrice && (
        <p className="mt-1 text-sm md:text-xs">
        <span className="font-semibold">Price:</span> £{proc.Price}
        </p>
      )}
            <div className="flex flex-row gap-4 md:gap-2 mt-2 md:mt-1">
                <p className="text-sm md:text-xs">
                    <span className="font-semibold">Start:</span> {formattedStartDate}
                </p>
                <p className="text-sm md:text-xs">
                    <span className="font-semibold">End:</span> {formattedEndDate}
                </p>
            </div>
        </div>
        <ChevronDoubleRightIcon className="hidden md:block w-8 h-8 flex-shrink-0" />
    </div>
);
})}

                        </div>
                    );
                    })}
            </nav>
                    
                </div>
                    )}

                {/* Main Content */}
                <div ref={projectScrollContainerRef} className={`w-full ${openProjectSteps ? "" : "md:w-1/2 lg:w-2/3 xl:w-2/3"} overflow-y-auto p-4 md:p-6 min-w-0`}>
{loading && (
  <LoadingComponent className="z-[9999]" showBackground={false} label="Working…" />
)}
<Dialog open={openProjectModal} onClose={() => {
  setOpenProjectModal(false);
}} className="relative z-50">
  <DialogBackdrop className="fixed inset-0 bg-gray-900/70 backdrop-blur-sm" />
  <div className="fixed inset-0 overflow-y-auto">
    <div className="flex min-h-full items-end sm:items-center justify-center p-0 sm:p-6">
      <DialogPanel className="w-full sm:max-w-3xl transform overflow-hidden rounded-none sm:rounded-2xl bg-white shadow-2xl">
        <div className="bg-gradient-to-r from-indigo-700 via-sky-600 to-emerald-500 px-5 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-white">Create Project</h2>
              <p className="text-xs text-white/90">Internal projects hide clients. External projects link a client + price.</p>
            </div>
            <button
              type="button"
              onClick={() => {
                setOpenProjectModal(false);
                setFormData(emptyFormData);
                setOpenReport(false);
              }}
              className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30"
              aria-label="Close"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-5 sm:p-6 space-y-5">
          <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="text-sm font-semibold text-gray-900">Project Type</div>
              <div className="inline-flex rounded-lg bg-white shadow-sm border border-gray-200 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setProjectType('Internal')}
                  className={`px-4 py-2 text-sm font-semibold ${formData.projectType === 'Internal' ? 'bg-indigo-600 text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                >
                  Internal
                </button>
                <button
                  type="button"
                  onClick={() => setProjectType('External')}
                  className={`px-4 py-2 text-sm font-semibold ${formData.projectType === 'External' ? 'bg-emerald-600 text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                >
                  External
                </button>
              </div>
            </div>

            {formData.projectType === 'External' && (
              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-900">Client</label>
                  <select
                    name="customerId"
                    value={formData.customerId}
                    onChange={handleInputChange}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
                  >
                    <option value="">Select client</option>
                    {customers
                      .slice()
                      .sort((a, b) => {
                        const aName = (a?.ClientName || '').toString().toLowerCase();
                        const bName = (b?.ClientName || '').toString().toLowerCase();
                        return aName.localeCompare(bName);
                      })
                      .map((customer) => {
                        const idValue = (customer?.id ?? '').toString();
                        const clientName = customer?.ClientName || 'Unnamed Client';
                        const contact = customer?.ContactName ? ` (${customer.ContactName})` : '';
                        const inactive = customer?.IsActive === 0 ? ' [inactive]' : '';
                        return (
                          <option key={idValue} value={idValue}>
                            {clientName}{contact}{inactive}
                          </option>
                        );
                      })}
                  </select>
                  {customersLoading && (<p className="mt-2 text-xs text-gray-600">Loading clients…</p>)}
                  {!customersLoading && customersError && (<p className="mt-2 text-xs text-red-600">{customersError}</p>)}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900">Price (£)</label>
                  <div className="mt-2 relative">
                    <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-sm text-gray-500">£</span>
                    <input
                      type="number"
                      inputMode="decimal"
                      min="0"
                      step="0.01"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      placeholder="0.00"
                      className="block w-full rounded-md bg-white pl-7 pr-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
                    />
                  </div>
                  <p className="mt-2 text-xs text-gray-600">Used for external quoting/billing.</p>
                </div>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-900">Project Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="e.g. January Staffing Ramp"
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-900">Start Date</label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleInputChange}
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900">End Date</label>
              <input
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleInputChange}
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900">On Site</label>
              <select
                name="onSite"
                value={formData.onSite}
                onChange={handleInputChange}
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900">Estimated Hours</label>
              <input
                type="number"
                name="estimatedHours"
                value={formData.estimatedHours}
                onChange={handleInputChange}
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>

              <div>
                <label className="block text-sm font-semibold text-gray-900">Brainstorm Board</label>
                <select
                  name="brainstormId"
                  value={formData.brainstormId}
                  onChange={handleInputChange}
                  className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
                >
                  <option value="">No linked brainstorm</option>
                  {brainstormBoards.map((board) => (
                    <option key={board.brainstormId} value={board.brainstormId}>
                      {(board.title || 'Untitled Brainstorm') + (board.projectId ? ` (${board.projectId})` : '')}
                    </option>
                  ))}
                </select>
                <p className="mt-2 text-xs text-gray-600">Optional: link a board so AI can use brainstorm context.</p>
              </div>


            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-900">Description</label>
              <textarea
                name="description"
                value={formData.description}
                rows={4}
                onChange={handleInputChange}
                placeholder="Short overview of the project"
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-900">Objective</label>
              <textarea
                name="objective"
                value={formData.objective}
                rows={4}
                onChange={handleInputChange}
                placeholder="What success looks like"
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-900">Processes</label>
              <select
                name="process"
                value={formData.process}
                onChange={handleSelectChange}
                multiple
                className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-indigo-600 min-h-[120px]"
              >
                <option value="">Select process</option>
                {processes.map((process) => (
                  <option key={process.id} value={process.Name} className="py-1">
                    {process.Name}
                  </option>
                ))}
              </select>
              <p className="mt-2 text-xs text-gray-600">Hold Ctrl/Cmd to select multiple.</p>
            </div>

            {formData.process.length > 0 && (
              <div className="md:col-span-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
                <div className="text-sm font-semibold text-gray-900">Selected Processes</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {formData.process.map((processId, index) => (
                    <span key={index} className="inline-flex items-center rounded-full bg-white px-3 py-1 text-xs font-semibold text-gray-700 border border-gray-200">
                      {processes.find((p) => p.Name === processId)?.Name || 'Unknown'}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col-reverse sm:flex-row items-center justify-end gap-3 pt-2">
            <button
              type="button"
              className="w-full sm:w-auto rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
              onClick={() => {
                setOpenProjectModal(false);
                setFormData(emptyFormData);
                setOpenReport(false);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              data-component="project-ai-report-form"
              data-time-saved="30"
              data-feature="generate_ai_report_post"
              className="w-full sm:w-auto inline-flex justify-center rounded-md bg-gradient-to-r from-blue-600 to-purple-600 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-purple-700"
            >
              {openReport ? 'Regenerate AI Report' : 'AI Report Creation'}
            </button>
          </div>

          {openReport && (
            <div className="pt-2">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <h3 className="text-lg font-semibold text-gray-900">AI Report</h3>
                <button
                  type="button"
                  onClick={() => setOpenReport(false)}
                  className="w-full sm:w-auto rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Hide report
                </button>
              </div>

              <div className="mt-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                <textarea
                  value={openReport}
                  onChange={(e) => setOpenReport(e.target.value)}
                  rows={10}
                  className="block w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />

                <div className="mt-4 flex flex-col-reverse sm:flex-row items-center justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      setOpenProjectModal(false);
                      setFormData(emptyFormData);
                      setOpenReport(false);
                    }}
                    className="w-full sm:w-auto rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={handleSaveData}
                    data-component="project-save"
                    data-time-saved="60"
                    data-feature="save_project"
                    className="w-full sm:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Save Project
                    <CheckBadgeIcon aria-hidden="true" className="-mr-0.5 size-5" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      </DialogPanel>
    </div>
  </div>
</Dialog>
{openProjectSteps && (
                <>
             
                <div ref={projectSectionRef} className="container mx-auto px-6 scroll-mt-24">
                    {/* Back button */}
                    {deleteModal && (
                  <div className="mb-10 rounded-2xl border border-rose-200/70 bg-gradient-to-r from-rose-600/90 to-red-500/90 shadow-[0_12px_30px_rgba(244,63,94,0.28)] animate-pulse">
                  <div className="px-4 py-5 sm:p-6">
                    <div className="sm:flex sm:items-start sm:justify-between">
                      <div>
                        <h3 className="text-base font-semibold text-white">Are you sure?</h3>
                        <div className="mt-2 max-w-xl text-sm text-white">
                          <p>
                            All Project Data will be lost
                          </p>
                        </div>
                      </div>
                      <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:shrink-0 sm:items-center">
                        <button onClick = {handleDeleteProject}
                          type="button"
                          className="inline-flex items-center rounded-xl border border-white/30 bg-white px-3 py-2 text-sm font-semibold text-rose-600 shadow-sm hover:bg-rose-50"
                        >
                          Delete
                        </button>
                        <button
                          type="button"
                          onClick={() => setDeleteModal(false)}
                          className="ml-3 inline-flex items-center rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                    <div 
  className="flex items-center justify-between p-4 rounded-2xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)]" 
 
>
  {/* Back Button */}
  <button
    onClick={() => {
      setOpenProjectSteps(false);
      setActiveProject(null);
      setActiveCustomer(null);
    }}
    className="inline-flex items-center gap-x-1 md:gap-x-2 rounded-xl border border-indigo-200/70 bg-white/85 px-2 py-1 text-xs md:px-3 md:py-2 md:text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
  >
    <ArrowLeftIcon className="h-4 w-4 md:h-5 md:w-5" />
    Back to Projects
  </button>


  {/* Active Switch */}
  
  <button 
    className="inline-flex items-center gap-x-1 md:gap-x-1.5 rounded-xl border border-white/20 bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-2 py-1 text-xs md:px-3 md:py-2 md:text-sm font-semibold text-white shadow-lg shadow-emerald-900/35 hover:from-emerald-600/95 hover:to-emerald-400/95"
    onClick={() => setOpenReport(true)}
  >
    Project Completed
  </button>
  {/* Delete Button */}
  <button 
    className="inline-flex items-center gap-x-1 md:gap-x-1.5 rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 px-2 py-1 text-xs md:px-3 md:py-2 md:text-sm font-semibold text-white shadow-lg shadow-rose-900/35 hover:from-rose-500/95 hover:to-red-400/95"
    onClick={() => setDeleteModal(true)}
  >
    Delete Project
  </button>
</div>

{(activeProject || activeCustomer || activeCustomerLoading) && (
  <div className="mt-6 rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-4">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div>
        <h3 className="text-base md:text-lg font-semibold text-indigo-950">Project Details</h3>
        <p className="text-xs text-indigo-500">Client info shows when a customer is linked.</p>
      </div>
      {activeProject && activeProject.Price !== null && activeProject.Price !== undefined && String(activeProject.Price).trim() !== '' && (
        <div className="inline-flex items-center rounded-full border border-indigo-200/70 bg-white/85 px-3 py-1 text-sm font-semibold text-indigo-700 shadow-sm">
          Price: £{activeProject.Price}
        </div>
      )}
    </div>

    {activeCustomerLoading && (
      <div className="mt-3 text-sm text-indigo-600">Loading customer…</div>
    )}

    {!activeCustomerLoading && activeCustomer && (
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="rounded-2xl border border-indigo-200/70 bg-white/85 p-4 shadow-[0_10px_24px_rgba(99,102,241,0.12)] transition-all duration-300 hover:-translate-y-1">
          <div className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Client</div>
          <div className="text-sm font-bold text-indigo-950 break-words mt-2">{activeCustomer.ClientName || '—'}</div>
        </div>
        <div className="rounded-2xl border border-indigo-200/70 bg-white/85 p-4 shadow-[0_10px_24px_rgba(99,102,241,0.12)] transition-all duration-300 hover:-translate-y-1">
          <div className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Telephone</div>
          <div className="text-sm font-bold text-indigo-950 break-words mt-2">{activeCustomer.Telephone || '—'}</div>
        </div>
        <div className="rounded-2xl border border-indigo-200/70 bg-white/85 p-4 shadow-[0_10px_24px_rgba(99,102,241,0.12)] transition-all duration-300 hover:-translate-y-1">
          <div className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Email</div>
          <div className="text-sm font-bold text-indigo-950 break-words mt-2">{activeCustomer.Email || '—'}</div>
        </div>
        <div className="rounded-2xl border border-indigo-200/70 bg-white/85 p-4 shadow-[0_10px_24px_rgba(99,102,241,0.12)] transition-all duration-300 hover:-translate-y-1 sm:col-span-2 lg:col-span-1">
          <div className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Address</div>
          <div className="text-sm font-bold text-indigo-950 break-words mt-2">{activeCustomer.ClientAddress || '—'}</div>
        </div>
      </div>
    )}
    
    {/* Action Buttons for Project */}
    {activeProject && activeCustomer && (
      <div className="mt-4 flex flex-wrap gap-2">
        {/* Google Maps Button - Always shown when postcode available */}
        {activeCustomer.Postcode && (
          <button
            onClick={() => handleOpenGoogleMaps(activeCustomer.Postcode)}
            className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95 transition-all"
          >
            <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            Directions
          </button>
        )}
        
        {/* Project Map Button - Only shown when project onSite === 1 */}
        {Number(activeProject.OnSite) === 1 && activeProject.GeoTag && (
          <button
            onClick={handleOpenProjectMap}
            className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-emerald-900/35 hover:from-emerald-600/95 hover:to-emerald-400/95 transition-all"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
            Project Map
          </button>
        )}
      </div>
    )}
  </div>
)}

{activeProject && (
  <div className="mt-6 rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-4">
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <h3 className="text-base md:text-lg font-semibold text-indigo-950">Project Objective And Description</h3>
      <span className="inline-flex items-center rounded-full border border-indigo-200/70 bg-white/85 px-3 py-1 text-xs font-semibold text-indigo-700 shadow-sm">
        {activeProject.ProjectType || 'Project'}
      </span>
    </div>
    <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="rounded-2xl border border-indigo-200/70 bg-gradient-to-br from-white/90 to-indigo-50/80 p-4 shadow-sm">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-indigo-600">Objective</h4>
        <p className="mt-2 text-sm text-indigo-900 whitespace-pre-wrap">
          {activeProject.Objective || activeProject.objective || 'No objective set for this project yet.'}
        </p>
      </div>
      <div className="rounded-2xl border border-indigo-200/70 bg-gradient-to-br from-white/90 to-sky-50/80 p-4 shadow-sm">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-indigo-600">Description</h4>
        <p className="mt-2 text-sm text-indigo-900 whitespace-pre-wrap">
          {activeProject.Description || activeProject.description || 'No description set for this project yet.'}
        </p>
      </div>
    </div>
  </div>
)}

{/* Project Map Modal */}
<ProjectMapModal
  isOpen={projectMapOpen}
  onClose={() => setProjectMapOpen(false)}
  companyGeoTag={companyGeoTag}
  clientGeoTag={activeProject?.GeoTag}
  projectName={activeProject?.Name}
  clientName={activeProject?.ClientName || activeCustomer?.ClientName}
  distance = {activeProject?.Distance}


/>

<div className="mt-10">
 

                        <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-4">
                            {stats.map((item) => (
                                <div
                                    key={item.id}
                              className="relative overflow-hidden rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl px-6 py-5 shadow-[0_12px_30px_rgba(99,102,241,0.16)] hover:shadow-[0_16px_36px_rgba(99,102,241,0.24)] transition duration-300"
                                >
                                    {/* Icon */}
                                    <dt className="flex items-center">
                                <div className="rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 p-3 shadow-lg shadow-indigo-950/35">
                                            <item.icon aria-hidden="true" className="size-6 text-white" />
                                        </div>
                                <p className="ml-4 text-sm font-medium text-indigo-600">{item.name}</p>
                                    </dt>
            
                                    {/* Statistic & Change Indicator */}
                                    <dd className="mt-3 flex items-center">
                                <p className="text-3xl font-semibold text-indigo-950">{item.stat}</p>
                                        <p
                                            className={classNames(
                                                item.changeType === "increase" ? "text-green-600" : "text-red-600",
                                                "ml-2 flex items-center text-sm font-semibold"
                                            )}
                                        >
                                            {item.changeType === "increase" ? (
                                                <ArrowUpIcon aria-hidden="true" className="size-5 text-green-500" />
                                            ) : (
                                                <ArrowDownIcon aria-hidden="true" className="size-5 text-red-500" />
                                            )}
                                            <span className="sr-only">
                                                {item.changeType === "increase" ? "Increased" : "Decreased"} by
                                            </span>
                                            {item.change}
                                        </p>
                                    </dd>
                                </div>
                            ))}
                        </dl>

                        {/* Financial Pie Chart for External Projects */}
                        {activeProject?.ProjectType === 'External' && activeProject.NetProfit !== undefined && activeProject.LaborCosts !== undefined && (
                          <div className="rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-6 mt-6">
                            <h3 className="text-lg font-semibold text-indigo-950 mb-4">Financial Breakdown</h3>
                            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                              {/* Pie Chart */}
                              <div className="flex-shrink-0" style={{ height: 250, width: 250 }}>
                                <VictoryPie
                                  data={[
                                    { x: 'Net Profit', y: Math.max(0, activeProject.NetProfit || 0) },
                                    { x: 'Labor Costs', y: activeProject.LaborCosts || 0 },
                                  ]}
                                  colorScale={[getProfitMarginColor(profitMargin), '#f97316']}
                                  labels={({ datum }) => `${datum.x}\n£${datum.y.toLocaleString()}`}
                                  labelComponent={
                                    <VictoryLabel style={{ fontSize: 12, fill: 'white', fontWeight: 'bold' }} />
                                  }
                                  innerRadius={60}
                                  padding={40}
                                />
                              </div>
                              
                              {/* Financial Stats */}
                              <div className="flex-1 space-y-4">
                                <div className="rounded-xl border border-indigo-200/70 bg-white/85 p-4 shadow-sm">
                                  <div className="flex justify-between items-center mb-2">
                                    <span className="text-sm font-medium text-indigo-600">Project Price</span>
                                    <span className="text-lg font-bold text-blue-600">
                                      £{(activeProject.Price || 0).toLocaleString()}
                                    </span>
                                  </div>
                                  <div className="flex justify-between items-center mb-2">
                                    <span className="text-sm font-medium text-indigo-600">Labor Costs</span>
                                    <span className="text-lg font-bold text-orange-600">
                                      -£{(activeProject.LaborCosts || 0).toLocaleString()}
                                    </span>
                                  </div>
                                  <div className="flex justify-between items-center pt-2 border-t border-indigo-200/70">
                                    <span className="text-sm font-semibold text-indigo-900">Net Profit</span>
                                    <span
                                      className={`text-lg font-bold ${
                                        (activeProject.NetProfit || 0) >= 0
                                          ? 'text-emerald-600'
                                          : 'text-red-600'
                                      }`}
                                    >
                                      £{(activeProject.NetProfit || 0).toLocaleString()}
                                    </span>
                                  </div>
                                </div>
                                
                                {/* Profit Margin */}
                                <div className="rounded-xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 p-4">
                                  <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-indigo-700">Profit Margin</span>
                                    <span
                                      className={`text-2xl font-bold ${
                                        profitMargin < 20
                                          ? 'text-red-600'
                                          : profitMargin <= 30
                                          ? 'text-yellow-600'
                                          : 'text-emerald-600'
                                      }`}
                                    >
                                      {profitMargin}%
                                    </span>
                                  </div>
                                  <div className="mt-2">
                                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                      <div
                                        className={`h-full ${
                                          profitMargin < 20
                                            ? 'bg-red-500'
                                            : profitMargin <= 30
                                            ? 'bg-yellow-500'
                                            : 'bg-emerald-500'
                                        }`}
                                        style={{ width: `${Math.min(profitMargin, 100)}%` }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                    <div ref={projectTabsRef}>
      {/* Desktop Tabs */}
      <div className="hidden sm:block mt-4">
        <div className="border-b border-indigo-200/70">
          <nav aria-label="Tabs" className="-mb-px mt-10 flex flex-wrap gap-2 items-center justify-center rounded-2xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 p-3 shadow-[0_12px_30px_rgba(99,102,241,0.16)] backdrop-blur-xl">
            {tabs.map((tab) => (
              <a
                key={tab.id}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(tab.id);
                }}
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.current
                    ? 'border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 text-white shadow-lg shadow-indigo-950/35'
                    : 'border-indigo-200/70 bg-white/75 text-indigo-700 hover:bg-white',
                  'group inline-flex items-center rounded-xl border px-4 py-2 text-sm font-medium transition-all',
                )}
              >
                <tab.icon
                  aria-hidden="true"
                  className={classNames(
                    tab.current ? 'text-white' : 'text-indigo-600 group-hover:text-indigo-800',
                    '-ml-0.5 mr-2 size-5',
                  )}
                />
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
                    
                    
    {(activeTab === 'flow' || activeTab === 'timeline') && (
            <div className="p-3 md:p-6 rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] mt-6 md:mt-10 relative">
              <h3 className="text-base md:text-lg font-semibold text-indigo-950 mb-2">{projectName}</h3>
                        
                        {/* Mobile-friendly info */}
                        <div className="block md:hidden mb-4">
                            <p className="text-xs text-indigo-700">
                                {activeTab === 'flow' ? 'Flow Chart View' : 'Timeline View'}
                            </p>
                            <p className="text-xs text-indigo-500 mt-1">
                                Pinch to zoom, drag to navigate
                            </p>
                        </div>
            
                        {/* Fullscreen Toggle Button */}
                        <button
                            onClick={toggleFullscreen}
                          className="mt-2 md:mt-4 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 text-white font-medium px-3 md:px-5 py-1.5 md:py-2 text-sm md:text-base shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95 transition"
                        >
                            {isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                        </button>
            
                        {/* Fullscreen Mode */}
                        <div
                            className={`transition-all duration-300 ease-in-out ${
                                isFullscreen ? "fixed inset-0 z-50" : "w-full h-64 md:h-80"
                            } bg-[#0A0F1E] rounded-xl shadow-lg overflow-hidden mt-4`}
                        >
                            {/* Close Fullscreen Button */}
                            {isFullscreen && (
                                <button
                                    onClick={toggleFullscreen}
                                    className="absolute top-3 md:top-5 right-3 md:right-5 rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 text-white px-3 md:px-4 py-1.5 md:py-2 shadow-lg shadow-rose-900/35 hover:from-rose-500/95 hover:to-red-400/95 transition z-10 text-sm md:text-base"
                                >
                                    Close Fullscreen
                                </button>
                                
                            )}
            
                            {/* ReactFlow Component */}
                            <ReactFlow
                                nodes={nodes}
                                edges={edges}
                                fitView
                                style={{ width: "100%", height: "100%" }}
                                onNodeClick={handleNodeClick}
                            >
                                <Controls />
                                <Background color="#444" gap={16} />
                            </ReactFlow>
            
                            {/* Node Details Modal */}
                            {selectedNode && (
  <div className="absolute bottom-0 left-0 w-full p-4 bg-gray-800 bg-opacity-90 rounded-t-xl">
    <NodeDetailsModal nodeData={selectedNode} onClose={() => setSelectedNode(null)} />
  </div>
)}

                        </div>
                    </div>
                    )}
                   

                    {/* Kanban Task Table */}
                  {activeTab === 'kanban' && (
                  <div className="mt-6 md:mt-10 rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-3 sm:p-4">
  <Kanban projectSteps={projectSteps} />
</div>
)}

{activeTab === 'meetings' && (
                    <div className="mt-6 md:mt-10">
                        {meetings.length > 0 && (
                                              <div className="rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl p-4 md:p-6 shadow-[0_12px_30px_rgba(99,102,241,0.16)]">
                              <div className='flex flex-col sm:flex-row sm:items-center justify-between gap-3'>
                                                  <h3 className="text-lg font-semibold text-indigo-950">Meetings</h3>
                                                  <button onClick={() => Navigate('/createmeeting')}  className="inline-flex items-center justify-center gap-x-1.5 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95"
      >
        <CalendarDaysIcon aria-hidden="true" className="-ml-0.5 size-5" />
                                  Schedule Meeting</button>
                              </div>
                                <ul className="mt-4 space-y-3 md:space-y-4">
                                {meetings.map((meeting) => {
  let meetingBackgroundColor = "bg-green-100"; // Default color
  let statusText = "Not Started";
  let showCancelButton = true;

  if (meeting.Start === 1 && meeting.Finished === 1) {
    meetingBackgroundColor = "bg-purple-100"; // Purple background for completed meeting
    statusText = "Meeting Completed";
    showCancelButton = false; // Hide Cancel button
  } else if (meeting.Start === 1 && meeting.Finished === 0) {
    meetingBackgroundColor = "bg-green-100 animate-pulse"; // Green background for in-progress meeting
    statusText = "In Progress";
  }

  return (
    <li 
      key={meeting.id} 
      className={`flex flex-col md:flex-row md:items-center justify-between p-4 rounded-2xl border border-indigo-200/70 shadow-sm transition-all space-y-3 md:space-y-0 ${meetingBackgroundColor}`}
    >
      <div className="flex-1">
        <h4 className="text-base font-semibold text-indigo-950">{meeting.Name}</h4>
        <p className="mt-1 text-sm text-indigo-700">{meeting.Notes}</p>
        
        {/* Status Display */}
        <p className="mt-2 text-sm font-semibold text-indigo-900">{statusText}</p>

        {/* Button to open Meeting Notes (Only shown if Notes exist) */}
        {meeting.MeetingNotes && (
          <button 
            onClick={() => alert(meeting.MeetingNotes)} 
            className="mt-2 text-sm text-indigo-600 underline"
          >
            View Notes
          </button>
        )}

        {/* Mobile: Date and Time */}
        <div className="flex flex-col sm:flex-row sm:gap-4 mt-2 md:hidden">
          <p className="text-sm text-indigo-700">{format(new Date(meeting.Date), "dd/MM/yyyy")}</p>
          <p className="text-sm text-indigo-700">{meeting.Time}</p>
        </div>

        {/* Start Meeting Button (Only shown if meeting is not completed) */}
        {showCancelButton && (
          <button  onClick={() => {
            const message = meeting
            Navigate('/meeting', { state: { meeting: message } });
          }}
          className="inline-flex items-center justify-center gap-x-1.5 rounded-xl mt-3 border border-white/20 bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-emerald-900/35 hover:from-emerald-600/95 hover:to-emerald-400/95 w-full sm:w-auto"
          >
            <CheckCircleIcon aria-hidden="true" className="-ml-0.5 size-5" />
            Start Meeting
          </button>
        )}
      </div>
      
      {/* Desktop: Date and Time */}
      <div className="hidden md:flex items-center gap-x-4 flex-shrink-0">
        <p className="text-sm text-indigo-700">{format(new Date(meeting.Date), "dd/MM/yyyy")}</p>
        <p className="text-sm text-indigo-700">{meeting.Time}</p>
      </div>
    </li>
  );
})}

                                </ul>
                            </div>
                        )}
                    </div>
                )}
                  
                      {/* Chat Component */}
                {activeTab === 'chat' && (
                    <div className="mt-6 md:mt-10">
                        <ProjectChat projectId={projectId} />
                    </div>
                )}

                {/* Brainstorm Tab */}
                {activeTab === 'brainstorm' && (
                    <div className="mt-6 md:mt-10">
                        <Brainstorm
                          brainstormId={activeProject?.BrainstormId || ''}
                          projectId={projectId}
                          projectName={projectName}
                        />
                    </div>
                )}

                {/* Materials Tab */}
                {activeTab === 'materials' && (
                  <div className="mt-6 md:mt-10">
                    {/* Material Modal */}
                    <Dialog open={openMaterialModal} onClose={() => setOpenMaterialModal(false)} className="relative z-50">
                      <DialogBackdrop className="fixed inset-0 bg-gray-900/70 backdrop-blur-sm" />
                      <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                          <DialogPanel className="w-full max-w-2xl transform overflow-hidden rounded-2xl border border-indigo-200/70 bg-white/90 backdrop-blur-xl shadow-[0_20px_45px_rgba(30,41,59,0.35)]">
                            <div className="bg-gradient-to-r from-indigo-900 via-sky-600 to-emerald-500 px-6 py-4">
                              <div className="flex items-center justify-between">
                                <h2 className="text-lg font-semibold text-white">
                                  {editingMaterialIndex !== null ? 'Edit Material' : 'Add Material'}
                                </h2>
                                <button onClick={() => setOpenMaterialModal(false)} className="text-white hover:text-indigo-100">
                                  <XMarkIcon className="h-6 w-6" />
                                </button>
                              </div>
                            </div>
                            <div className="p-6 space-y-4">
                              <div>
                                <label className="block text-sm font-semibold text-gray-900">Name *</label>
                                <input
                                  type="text"
                                  name="name"
                                  value={materialFormData.name}
                                  onChange={handleMaterialInputChange}
                                  placeholder="e.g. Bricks - red engineering"
                                  className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                  required
                                />
                              </div>
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <label className="block text-sm font-semibold text-gray-900">Category</label>
                                  <select
                                    name="category"
                                    value={materialFormData.category}
                                    onChange={handleMaterialInputChange}
                                    className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                  >
                                    <option value="">Select category</option>
                                    <option value="Materials">Materials</option>
                                    <option value="Consumables">Consumables</option>
                                    <option value="Equipment">Equipment</option>
                                  </select>
                                </div>
                                <div>
                                  <label className="block text-sm font-semibold text-gray-900">Quantity *</label>
                                  <input
                                    type="number"
                                    name="quantity"
                                    value={materialFormData.quantity}
                                    onChange={handleMaterialInputChange}
                                    min="0"
                                    step="any"
                                    className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <label className="block text-sm font-semibold text-gray-900">Unit *</label>
                                  <input
                                    type="text"
                                    name="unit"
                                    value={materialFormData.unit}
                                    onChange={handleMaterialInputChange}
                                    placeholder="e.g. units, packs, metres"
                                    className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                    required
                                  />
                                </div>
                                <div>
                                  <label className="block text-sm font-semibold text-gray-900">Unit Cost (£)</label>
                                  <input
                                    type="number"
                                    name="unit_cost"
                                    value={materialFormData.unit_cost}
                                    onChange={handleMaterialInputChange}
                                    min="0"
                                    step="0.01"
                                    className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                  />
                                </div>
                              </div>
                              <div>
                                <label className="block text-sm font-semibold text-gray-900">Supplier</label>
                                <input
                                  type="text"
                                  name="supplier"
                                  value={materialFormData.supplier}
                                  onChange={handleMaterialInputChange}
                                  placeholder="e.g. Local Builders Merchant"
                                  className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-semibold text-gray-900">Notes</label>
                                <textarea
                                  name="notes"
                                  value={materialFormData.notes}
                                  onChange={handleMaterialInputChange}
                                  rows={3}
                                  placeholder="Additional information"
                                  className="mt-2 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600"
                                />
                              </div>
                              <div className="flex gap-6">
                                <button
                                  onClick={() => setOpenMaterialModal(false)}
                                  className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleSaveMaterial}
                                  className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
                                >
                                  {editingMaterialIndex !== null ? 'Update' : 'Add'} Material
                                </button>
                              </div>
                            </div>
                          </DialogPanel>
                        </div>
                      </div>
                    </Dialog>

                    {/* Materials Stats Dashboard */}
                    {formData.materials && formData.materials.length > 0 && (
                      <div className="rounded-2xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-4 sm:p-6 mb-6">
                        <div className="flex items-center gap-2 mb-4">
                          <CubeIcon className="h-6 w-6 text-indigo-600" />
                          <h3 className="text-base sm:text-lg font-semibold text-indigo-950">Material Usage Overview</h3>
                        </div>
                        <div className="space-y-4">
                          {formData.materials.map((material, index) => {
                            const originalQuantity = parseFloat(material.quantity) + parseFloat(material.usedquantity || 0);
                            const usedQuantity = parseFloat(material.usedquantity || 0);
                            const remainingQuantity = parseFloat(material.quantity);
                            const usedPercentage = originalQuantity > 0 ? (usedQuantity / originalQuantity) * 100 : 0;
                            const remainingPercentage = originalQuantity > 0 ? (remainingQuantity / originalQuantity) * 100 : 100;
                            
                            return (
                              <div key={index} className="rounded-xl border border-indigo-200/70 bg-white/85 p-3 sm:p-4 shadow-sm">
                                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
                                  <div className="flex-1">
                                    <h4 className="font-semibold text-indigo-950 text-sm sm:text-base">{material.name}</h4>
                                    <p className="text-xs sm:text-sm text-indigo-700">
                                      {material.category && `${material.category} • `}
                                      {material.supplier && `${material.supplier}`}
                                    </p>
                                  </div>
                                  <div className="flex gap-4 text-xs sm:text-sm">
                                    <div className="text-center">
                                      <p className="font-semibold text-green-600">{usedQuantity.toFixed(1)}</p>
                                      <p className="text-indigo-500">Used</p>
                                    </div>
                                    <div className="text-center">
                                      <p className="font-semibold text-indigo-600">{remainingQuantity.toFixed(1)}</p>
                                      <p className="text-indigo-500">Remaining</p>
                                    </div>
                                    <div className="text-center">
                                      <p className="font-semibold text-indigo-900">{originalQuantity.toFixed(1)}</p>
                                      <p className="text-indigo-500">Total</p>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Progress bar */}
                                <div className="relative h-6 sm:h-8 bg-gray-200 rounded-full overflow-hidden">
                                  {/* Used portion (green) */}
                                  <div 
                                    className="absolute left-0 top-0 h-full bg-gradient-to-r from-green-400 to-green-500 transition-all duration-500"
                                    style={{ width: `${usedPercentage}%` }}
                                  />
                                  {/* Remaining portion (indigo) */}
                                  <div 
                                    className="absolute top-0 h-full bg-gradient-to-r from-indigo-400 to-indigo-500 transition-all duration-500"
                                    style={{ left: `${usedPercentage}%`, width: `${remainingPercentage}%` }}
                                  />
                                  {/* Percentage text overlay */}
                                  <div className="absolute inset-0 flex items-center justify-center">
                                    <span className="text-xs sm:text-sm font-semibold text-white drop-shadow-lg">
                                      {usedPercentage.toFixed(0)}% used • {remainingPercentage.toFixed(0)}% remaining
                                    </span>
                                  </div>
                                </div>
                                
                                {/* Usage details if material has been used */}
                                {material.used && material.usedtaskname && (
                                  <div className="mt-2 pt-2 border-t border-indigo-200/70">
                                    <p className="text-xs text-indigo-600">
                                      Last used in: <span className="font-medium text-indigo-900">{material.usedtaskname}</span>
                                      {material.usedTime && ` • ${new Date(material.usedTime).toLocaleString()}`}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Materials List */}
                    <div className="rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-6">
                      <div className="flex items-center justify-between mb-6">
                        <h3 className="text-lg font-semibold text-indigo-950">Project Materials</h3>
                        <button
                          onClick={handleAddMaterial}
                          className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95"
                        >
                          <PencilIcon className="h-5 w-5" />
                          Add Material
                        </button>
                      </div>

                      {formData.materials && formData.materials.length > 0 ? (
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Unit Cost</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Supplier</th>
                                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Bought</th>
                                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Used</th>
                                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                              {formData.materials.map((material, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                  <td className="px-4 py-3 text-sm text-gray-900">{material.name}</td>
                                  <td className="px-4 py-3 text-sm text-gray-600">{material.category || '-'}</td>
                                  <td className="px-4 py-3 text-sm text-gray-900">{material.quantity}</td>
                                  <td className="px-4 py-3 text-sm text-gray-900">
                                    {material.unit_cost ? `£${parseFloat(material.unit_cost).toFixed(2)}` : '-'}
                                  </td>
                                  <td className="px-4 py-3 text-sm text-gray-600">{material.supplier || '-'}</td>
                                  <td className="px-4 py-3 text-center">
                                    <button
                                      onClick={() => handleToggleBought(index)}
                                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                        material.bought
                                          ? 'bg-green-100 text-green-800'
                                          : 'bg-red-100 text-red-800'
                                      }`}
                                    >
                                      {material.bought ? 'Yes' : 'No'}
                                    </button>
                                  </td>
                                  <td className="px-4 py-3 text-center">
                                    <button
                                      onClick={() => handleToggleUsed(index)}
                                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                        material.used
                                          ? 'bg-green-100 text-green-800'
                                          : 'bg-gray-100 text-gray-800'
                                      }`}
                                    >
                                      {material.used ? 'Yes' : 'No'}
                                    </button>
                                  </td>
                                  <td className="px-4 py-3 text-right space-x-2">
                                    <button
                                      onClick={() => handleEditMaterial(index)}
                                      className="text-indigo-600 hover:text-indigo-900 text-sm font-medium"
                                    >
                                      Edit
                                    </button>
                                    <button
                                      onClick={() => handleDeleteMaterial(index)}
                                      className="text-red-600 hover:text-red-900 text-sm font-medium"
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p className="text-center text-gray-500 py-8">No materials added yet. Click "Add Material" to get started.</p>
                      )}
                    </div>

                    {/* Shopping List */}
                    {formData.materials && formData.materials.filter(m => !m.bought).length > 0 && (
                      <div className="mt-6 rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-6">
                        <div className="flex items-center gap-2 mb-4">
                          <DocumentCheckIcon className="h-6 w-6 text-amber-600" />
                          <h3 className="text-lg font-semibold text-indigo-950">Shopping List</h3>
                          <span className="ml-auto rounded-full border border-indigo-200/70 bg-white/85 text-indigo-700 px-3 py-1 text-sm font-semibold shadow-sm">
                            {formData.materials.filter(m => !m.bought).length} items
                          </span>
                        </div>
                        <div className="space-y-3">
                          {formData.materials
                            .map((material, index) => ({ ...material, originalIndex: index }))
                            .filter(m => !m.bought)
                            .map((material) => (
                              <div key={material.originalIndex} className="rounded-xl border border-indigo-200/70 bg-white/85 p-4 shadow-sm">
                                <div className="flex items-start justify-between">
                                  <div className="flex-1">
                                    <h4 className="font-semibold text-indigo-950">{material.name}</h4>
                                    <p className="text-sm text-indigo-700 mt-1">
                                      Quantity: {material.quantity}
                                      {material.unit_cost > 0 && (
                                        <span className="ml-2 font-medium text-indigo-900">
                                          @ £{parseFloat(material.unit_cost).toFixed(2)} = £{(material.quantity * material.unit_cost).toFixed(2)}
                                        </span>
                                      )}
                                    </p>
                                    {material.supplier && (
                                      <p className="text-sm text-indigo-500 mt-1">Supplier: {material.supplier}</p>
                                    )}
                                    {material.notes && (
                                      <p className="text-sm text-indigo-500 mt-1 italic">{material.notes}</p>
                                    )}
                                  </div>
                                  <button
                                    onClick={() => handleToggleBought(material.originalIndex)}
                                    className="ml-4 px-4 py-2 rounded-xl border border-white/20 bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 text-white text-sm font-semibold shadow-lg shadow-emerald-900/35 hover:from-emerald-600/95 hover:to-emerald-400/95"
                                  >
                                    Mark Bought
                                  </button>
                                </div>
                              </div>
                            ))}
                        </div>
                        {formData.materials.filter(m => !m.bought && m.unit_cost > 0).length > 0 && (
                          <div className="mt-4 pt-4 border-t border-indigo-200/70">
                            <div className="flex justify-between items-center">
                              <span className="text-lg font-semibold text-indigo-900">Total Estimated Cost:</span>
                              <span className="text-2xl font-bold text-indigo-900">
                                £{formData.materials
                                  .filter(m => !m.bought)
                                  .reduce((sum, m) => sum + (m.quantity * (m.unit_cost || 0)), 0)
                                  .toFixed(2)}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Daily Report Tab */}
                {activeTab === 'daily-report' && (() => {
                  const dailyReports = (() => {
                    try {
                      const raw = activeProject?.DailyReport;
                      if (!raw) return [];
                      return typeof raw === 'string' ? JSON.parse(raw) : raw;
                    } catch {
                      return [];
                    }
                  })();

                  return (
                    <div className="mt-6 md:mt-10 space-y-4">
                      <div className="rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)] p-6">
                        <div className="flex items-center gap-3 mb-6">
                          <DocumentChartBarIcon className="h-6 w-6 text-indigo-600" />
                          <h3 className="text-lg font-semibold text-indigo-950">Daily Reports</h3>
                          <span className="ml-auto rounded-full border border-indigo-200/70 bg-indigo-50 text-indigo-700 px-3 py-1 text-sm font-semibold shadow-sm">
                            {dailyReports.length} {dailyReports.length === 1 ? 'report' : 'reports'}
                          </span>
                        </div>

                        {dailyReports.length === 0 ? (
                          <div className="flex flex-col items-center justify-center py-16 text-center">
                            <DocumentChartBarIcon className="h-12 w-12 text-indigo-200 mb-4" />
                            <p className="text-indigo-700 font-medium">No daily reports yet</p>
                            <p className="text-sm text-indigo-400 mt-1">Reports are generated automatically overnight at 3am.</p>
                          </div>
                        ) : (
                          <div className="space-y-4">
                            {[...dailyReports].reverse().map((entry, idx) => (
                              <div
                                key={idx}
                                className="rounded-xl border border-indigo-200/70 bg-gradient-to-br from-white/90 to-indigo-50/60 p-5 shadow-sm"
                              >
                                <div className="flex items-center gap-2 mb-3">
                                  <span className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-indigo-900 to-indigo-600 px-3 py-1 text-xs font-semibold text-white shadow">
                                    <CalendarDaysIcon className="h-3.5 w-3.5" />
                                    {entry.date
                                      ? new Date(entry.date).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' })
                                      : 'Unknown date'}
                                  </span>
                                </div>
                                <div className="text-sm text-gray-800 whitespace-pre-wrap leading-relaxed">
                                  {entry.report || <span className="text-gray-400 italic">No report content.</span>}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {}
            
                {activeTab === 'tasks' && (
                    <div className="w-full mt-6 md:mt-10">
                        <ProjectDailyTasks 
                          ProjectId={projectId} 
                          ProjectName={projectName} 
                          onDataChange={handleChildDataChange}
                        />
                    </div>
                )}
                      
                        <ProjectDailyTasks 
                          ProjectId={projectId} 
                          ProjectName={projectName}
                          onDataChange={handleChildDataChange}
                        />
                    </div>
            </>
            )}

            {/* Mobile project tabs (only when project open) */}
            {openProjectSteps && (
              <div className="sm:hidden fixed bottom-0 left-0 right-0 z-50">
                <div className="mx-auto mb-3 w-full max-w-screen-sm overflow-x-auto rounded-2xl bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border border-indigo-200/70 shadow-[0_12px_30px_rgba(99,102,241,0.16)] px-3 py-2">
                  <div className="flex w-max items-center gap-2">
                    {tabs.map((tab) => {
                      const isActive = activeTab === tab.id;
                      return (
                        <button
                          key={`mobile-project-tab-${tab.id}`}
                          type="button"
                          onClick={() => {
                            setActiveTab(tab.id);
                            scrollToProjectSection();
                          }}
                          aria-label={tab.name}
                          title={tab.name}
                          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-all ${
                            isActive
                              ? 'bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 text-white shadow-lg shadow-indigo-950/35'
                              : 'bg-white/80 text-indigo-600 border border-indigo-200/70 hover:bg-white'
                          }`}
                        >
                          <tab.icon className="h-5 w-5" />
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
                 

                    




                

                    {/* Tabs for Larger Screens */}
             
                    {/* Content Rendering */}
                 
                 </div>
                 </div>
                 </div>
                 </div>

    </div>

    </>
);
}
